var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"seasidetms_header_contacts_link",attrs:{"to":_vm.lang ? '/' + _vm.lang + '/contacts' : '/contacts'}},[_c('span',{staticClass:"seasidetms_header_contacts_link-icon seasidetms-icon-phone-alt"})])}
var staticRenderFns = []

export { render, staticRenderFns }